import React, { useState } from "react";
import styled from "styled-components"

import OracleInputCurrency from "./OracleInputCurrency";
import CurrencyLogo from "./CurrencyLogo";
import OracleInputSymbol from "./OracleInputSymbol";

import { IMAGES_FOLDER, secondToAnnualFactor } from "../config"

const _OracleResult = styled.div`

	display: flex;
	flex-direction: row;
	justify-content: space-between;

    color: ${({ theme }) => theme.panelTextColor};
    background-color: ${({ theme }) => theme.panelBackgroundColor};

	font-size: 1em;
	overflow: hidden;
	padding: 0.75em;
	outline: none;
	font-weight: normal;
	text-decoration: none;
	text-align: right;


	/* Tablets */
	@media (max-width: 1400px) {
			font-size: 0.85rem;
	}

	/* Mobiles */
	@media (max-width: 640px) {
		font-size: 0.6rem;
	}

`;

const _OracleResultValue = styled.span`

    color: ${({ theme, alwaysPositive, value }) => (alwaysPositive || value == 0) ? "inherited": (value > 0 ? theme.oracleResultTextColorPositive :  theme.oracleResultTextColorNegative)};

	cursor: pointer;
	font-size: 1.25em;
	font-weight: bold;

	&:hover {
		opacity: 0.8;
	}

`;

const _OracleResultScale = styled.span`

	font-size: 0.75em;

`;


function OracleResult(props) {
	return(
		<_OracleResult>
			<div>
			<CurrencyLogo src={require("../" + IMAGES_FOLDER + props.tokenOut["symbol"].toLowerCase() + "-logo.png")}/>
			<CurrencyLogo src={require("../" + IMAGES_FOLDER + props.tokenIn["symbol"].toLowerCase() + "-logo.png")}/>
			</div>
			<div>
				<span>return: </span>
				<_OracleResultValue value={props.mean}>{(props.mean).toExponential(3)}%</_OracleResultValue> <_OracleResultScale>(sec)</_OracleResultScale>
			</div>
			<span style={{verticalAlign: "middle", textlAlign: "center", alignSelf: "center"}}> | </span>
			<div>
				<span>volatility: </span>
				<_OracleResultValue alwaysPositive={true}>{(100 * Math.sqrt(props.variance)).toExponential(3)}%</_OracleResultValue> <_OracleResultScale>(sec)</_OracleResultScale>
			</div>
		</_OracleResult>
	)
}

export default OracleResult;